import { StylovyzeIconProps } from '@innovyze/stylovyze';
import React from 'react';


const MercuryIcon: React.FC<StylovyzeIconProps> = ({
	color,
	...props
}: StylovyzeIconProps) => {
	return (
<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.5 4.04492H20.5V10.0449H12.5V4.04492ZM12.5 21.0449V11.0449H20.5V21.0449H12.5ZM3.5 21.0449V15.0449H11.5V21.0449H3.5ZM3.5 14.0449V4.04492H11.5V14.0449H3.5ZM4.5 5.04492V13.0449H10.5V5.04492H4.5ZM13.5 5.04492V9.04492H19.5V5.04492H13.5ZM13.5 12.0449V20.0449H19.5V12.0449H13.5ZM4.5 16.0449V20.0449H10.5V16.0449H4.5Z" fill="white"/>
</svg>
	);
}

export default MercuryIcon;
